module.exports = __webpack_public_path__ + "static/media/500-rubles.185b36fb.svg";